export default __webpack_public_path__ + "static/volume-aedf9a4285d683d1400a6a975e849579.png";